import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { ObjectTypeEnum, ObjectTypeEnumText } from "../../../../../models/ObjectTypeEnum";
import { postsApi } from "../../../../../utils";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import CollapsedPost from './CollapsedPost'
import EditPost from './EditPost'
import classes from './PostPopUp.module.css'
import useShareTypes from '../../../../../hooks/useShareTypes'
import { TargetObjectIdEnum } from "../../../../../models/TargetObjectIdEnum";
import { onKeyDown } from "../../../../../service";
import SuccessProjectPopup from "../../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";

const PostPopUp = ({ fromProjectPage, post, close, project, beenSharedBefore, setBeenSharedBefore, setProjectData, myHeight, changePosts, newPost, setNewPost, setClickShowShareProjectPopup, friendsData, saveVersion }) => {
    const [dataPost, setDataPost] = useState()
    const dispatch = useDispatch()
    const { direction, texts } = useSelector((state) => state.translate);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const [showPopup, setShowPopup] = useState(null)
    const [showNewEditPost, setShowNewEditPost] = useState(false)
    const [editPostFromPosts, setEditPostFromPosts] = useState(false)
    const [showEditPost, setShowEditPost] = useState(-1)
    const [loading, setLoading] = useState(true)
    const selectedList = useShareTypes()
    const { user } = useSelector(state => state.auth);

    useEffect(() => {
        if (!post) {
            if (newPost) {
                setLoading(false)
                setEditPostFromPosts(true)
                setShowEditPost(0)
            }
            else {
                const data = {
                    refObjectId: project?.id,
                    refObjectType: ObjectTypeEnumText.Project,
                    sourceObjectId: user.id,
                    sourceObjectType: ObjectTypeEnumText.User
                }
                postsApi.postsFilterRangePost({ postsRangeFilter: data }, (error, resdata, response) => {

                    if (error) {
                        if (!response?.error?.status === 404)
                            dispatch(throwApiError({ userMessage: texts.MessageTitleProjectSharePost, error: error, statusCode: response?.statusCode, message: "postsFilterPost " + error.message, level: 1, component: "ShareProjectPopup", line: 28 }))
                    }
                    else {
                        if (resdata.length > 0) {
                            if (fromProjectPage) {
                                setBeenSharedBefore(true)

                            }
                            setDataPost(resdata)
                        }

                        setLoading(false)

                    }
                })
            }

        }
        else {
            setDataPost([post])
            setLoading(false)
            setEditPostFromPosts(true)
            setShowEditPost(0)
        }
    }, []);


    const getSelectedList = () => {
        let current = {}
        if (Array.isArray(dataPost)) {
            Object.keys(selectedList()).forEach(x => {
                if (x == ObjectTypeEnum.External) {
                    if (dataPost.filter(d => d.shares[0].targetObjectId === TargetObjectIdEnum.External).length == 0) {
                        current[x] = selectedList()[x]
                    }
                }
                else {
                    if (dataPost.filter(d => ObjectTypeEnum[d.shares[0].targetObjectType] == x && d.shares[0].targetObjectId !== TargetObjectIdEnum.External).length == 0) {
                        current[x] = selectedList()[x]
                    }
                }
            })
        }
        else {
            current = selectedList()
        }
        if (studyGroup?.allowSelfRegister) {
            delete current[ObjectTypeEnum.User];
        }
        return current;
    }

    const handleCurrntOpenEdit = (index) => {
        if (showEditPost != index) {
            setShowEditPost(index)
            setShowNewEditPost(false)
        }
        else {
            setShowEditPost(-1)
        }

    }

    const handleShowNewEditPost = () => {
        setShowNewEditPost(true)
        setShowEditPost(-1)
    }

    const getPostDescriptionType = (p) => {
        if (p?.shares?.[0]?.targetObjectId == TargetObjectIdEnum.External) {
            return selectedList()[Object.keys(selectedList()).find(x => x == ObjectTypeEnum.External)]
        }
        return selectedList()[Object.keys(selectedList()).find(x => x == ObjectTypeEnum[p?.shares?.[0]?.targetObjectType])]
    }
    return (
        <>
            {!showPopup ?
                <div>
                    <SuccessProjectPopup setClickShowShareProjectPopup={setClickShowShareProjectPopup} title={texts.shareProject} color="#CCF0F0" close={() => close()} myHeight={'fit-content'} myWidth={'554px'} direction={direction} padding={'40px 0 20px 0'} setNewPost={setNewPost}>
                        {!loading ?
                            dataPost && beenSharedBefore ?
                                <div>
                                    {dataPost.map((p, i) =>
                                        <div key={i}>
                                            <CollapsedPost
                                                setBeenSharedBefore={setBeenSharedBefore}
                                                editPostFromPosts={editPostFromPosts}
                                                close={() => close()}
                                                index={i}
                                                setShowEditPost={handleCurrntOpenEdit}
                                                showEditPost={i == showEditPost ? true : false}
                                                setShowPopup={setShowPopup}
                                                dataPost={p}
                                                allPost={dataPost}
                                                postDescriptionType={getPostDescriptionType(p)}
                                                project={project}
                                                beenSharedBefore={beenSharedBefore}
                                                setProjectData={setProjectData}
                                                getSelectedList={getSelectedList}
                                                showNewEditPost={showNewEditPost}
                                                changePosts={changePosts}
                                                newPost={newPost}
                                                setNewPost={setNewPost}
                                                setDataPost={setDataPost}
                                                friendsData={friendsData}
                                                saveVersion={saveVersion}
                                            />
                                        </div>
                                    )}
                                    {(studyGroup?.allowSelfRegister ? dataPost.length < Object.keys(selectedList()).length - 1 : dataPost.length < Object.keys(selectedList()).length) && !showNewEditPost && !post &&
                                        <div>
                                            <div className={classes.AddBtnWarrper} onClick={() => handleShowNewEditPost()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleShowNewEditPost())}>
                                                <div className={classes.AddBtn}></div>
                                                < div className={classes.AddPostText} >{texts.publishNewPost}</div>
                                            </div>
                                            <div className={classes.Line}></div>
                                        </div>
                                    }
                                    {showNewEditPost &&
                                        <EditPost
                                            setLoading={setLoading}
                                            getSelectedList={getSelectedList}
                                            close={close}
                                            setShowPopup={setShowPopup}
                                            project={project}
                                            beenSharedBefore={false}
                                            setBeenSharedBefore={setBeenSharedBefore}
                                            newPost={newPost}
                                            setNewPost={setNewPost}
                                            setDataPost={setDataPost}
                                            changePosts={changePosts}
                                            friendsData={friendsData}
                                            saveVersion={saveVersion}
                                        />}
                                </div>
                                : <EditPost
                                    setLoading={setLoading}
                                    getSelectedList={getSelectedList}
                                    setShowPopup={setShowPopup}
                                    close={() => close()}
                                    setProjectData={setProjectData}
                                    setBeenSharedBefore={setBeenSharedBefore}
                                    dataPost={dataPost} project={project}
                                    beenSharedBefore={beenSharedBefore}
                                    newPost={newPost}
                                    setNewPost={setNewPost}
                                    setDataPost={setDataPost}
                                    changePosts={changePosts}
                                    setClickShowShareProjectPopup={setClickShowShareProjectPopup}
                                    friendsData={friendsData}
                                    saveVersion={saveVersion}
                                /> : <div className={classes.Loader}></div>
                        }

                    </SuccessProjectPopup >
                </div >
                :
                showPopup}
        </>
    )
}
export default PostPopUp